import { Fraction } from 'bi-fraction';
import { BONDING_SUPPLY, BONDING_TOKEN_DECIMALS } from '../constants';
export const getMcapAtGraduation = ({ gradThreshold, k, }) => {
    const initialSupply = new Fraction(BONDING_SUPPLY).shr(BONDING_TOKEN_DECIMALS);
    const bondingPriceAtGraduation = k.div(gradThreshold.mul(gradThreshold));
    const mcap = initialSupply.mul(bondingPriceAtGraduation);
    return mcap;
};
